import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Spin2Win from '../../components/Spin2Win.js';
import SidebarTabButton from '../../components/builder/SidebarTabButton.js';
import PopupPreview from '../../components/builder/PopupPreview.js';
import Notification from '../../components/Notification.js';
import stringify from 'json-stable-stringify';
import GeneralHelper from '../../modules/General.js';
import NewsletterListPicker from '../../components/NewsletterListPicker.js';
import Switch from 'rc-switch';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import SidebarElementHeader from '../../components/builder/SidebarElementHeader.js';
import CodeMirror from 'react-codemirror';
import '../../../../node_modules/codemirror/mode/css/css.js';
import SidebarSettingAccordion from '../../components/builder/SidebarSettingAccordion.js';
import SidebarElementSpacing from '../../components/builder/SidebarElementSpacing.js';
import SidebarElementWrapper from '../../components/builder/SidebarElementWrapper.js';
import SidebarElementSetting from '../../components/builder/SidebarElementSetting.js';
import CKeditor from '../../components/CKeditor.js';
import ColorPicker from '../../components/builder/ColorPicker.js';
import BorderPicker from '../../components/builder/BorderPicker.js';
import CustomCss from '../../components/builder/CustomCss.js';
import PopupSetting from '../../helpers/PopupSetting.js';
import Nav from './Nav';
import {popupRemoveRule, popupSetSettingData, popupSetRule, popupSetGlobalKey, popupSetPopupKey, popupSetContentData, popupSetStyleData, popupSetStyle} from '../../actions/builderPopup.js';
import Dropzone from 'react-dropzone';
import RulePicker from '../../components/builder/RulePicker.js';

import RuleRunMax from '../../components/builder/RuleRunMax.js';
import RuleRunTimeSpent from '../../components/builder/RuleRunTimeSpent.js';
import RuleShowToProductName from '../../components/builder/RuleShowToProductName.js';
import RuleShowToCartSum from '../../components/builder/RuleShowToCartSum.js';
import RuleShowToLeaving from '../../components/builder/RuleShowToLeaving.js';
import RuleShowToReturning from '../../components/builder/RuleShowToReturning.js';
import RuleShowOnPath from '../../components/builder/RuleShowOnPath.js';
import RuleShowToReferrer from '../../components/builder/RuleShowToReferrer.js';
import RuleRunAfter from '../../components/builder/RuleRunAfter.js';
import RuleShowOnDevice from '../../components/builder/RuleShowOnDevice.js';
import RuleShowToVisitorType from '../../components/builder/RuleShowToVisitorType.js';
import RuleHideFromReferrer from '../../components/builder/RuleHideFromReferrer.js';
import RuleHideOnPath from '../../components/builder/RuleHideOnPath.js';
import LoadingSmall from '../../components/LoadingSmall.js';

import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import General from '../../modules/General';
import DiscountPicker from "../../components/builder/DiscountPicker";

import DatePicker from 'react-datepicker';
import moment from 'moment';
import UpgradeRequired from "../../components/UpgradeRequired";
import RuleRunPrDay from "../../components/builder/RuleRunPrDay";


const components = {
    RuleShowOnDevice,
    RuleRunAfter,
    RuleShowToReferrer,
    RuleShowOnPath,
    RuleRunMax,
    RuleShowToProductName,
    RuleShowToCartSum,
    RuleShowToLeaving,
    RuleShowToReturning,
    RuleHideFromReferrer,
    RuleShowToVisitorType,
    RuleHideOnPath,
    RuleRunTimeSpent,
    RuleRunPrDay,
};


class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isError: false,
            isAddingRule: false,
            types: {},
            customCssOpen: false,
            css: '',
            isUploading: false,
            showOverview: false,
            isAddingDiscount: false,
        }

        this.codeMirrorOptions = {
            lineNumbers: true,
            mode: 'text/css',
        };

        this.handleHtmlChange = this.handleHtmlChange.bind(this);
        this.setStage = this.setStage.bind(this);
        this.stageTypes = this.stageTypes.bind(this);
        this.clickedContentBox = this.clickedContentBox.bind(this);
        this.renderComponent = this.renderComponent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleBorderChange = this.handleBorderChange.bind(this);
        this.renderCss = this.renderCss.bind(this);
        this.resetCss = this.resetCss.bind(this);
        this.handleCssChange = this.handleCssChange.bind(this);
        this.saveCss = this.saveCss.bind(this);
        this.renderContainer = this.renderContainer.bind(this);
        this.save = this.save.bind(this);
        this.overview = this.overview.bind(this);
        this.handleDisableStage = this.handleDisableStage.bind(this);
        this.renderMail = this.renderMail.bind(this);
        this.handleAppSave = this.handleAppSave.bind(this);
        this.renderRule = this.renderRule.bind(this);
        this.handleImageUpload = this.handleImageUpload.bind(this);
        this.handleClickUpload = this.handleClickUpload.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePopupChange = this.handlePopupChange.bind(this);
        this.handleDataChange = this.handleDataChange.bind(this);
        this.sidebarSuccess = this.sidebarSuccess.bind(this);
        this.addRule = this.addRule.bind(this);
        this.handleUseActivation = this.handleUseActivation.bind(this);
        this.handleScheduleChange = this.handleScheduleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    addRule(rule) {
        this.props.popupSetRule(rule.id, rule);
        this.setState({isAddingRule: false});
    }

    sidebarSuccess() {
        if (typeof this.state.types['crall-container'] === 'undefined') {
            return <SidebarTabButton setSelectedTab={this.setStage} colSize="col-sm-3" disabled={false} selectedTab={this.props.builderPopup.stage} tab="3" text="Success" />;
        }

        let disabled = true;

        this.state.types['crall-container'].map(item => {
            if (item.id == 'container-stage-3') {
                disabled = false;
            }
        });

        return <SidebarTabButton setSelectedTab={this.setStage} colSize="col-sm-3" disabled={disabled} selectedTab={this.props.builderPopup.stage} tab="3" text="Success" />;

    }

    handleDataChange(e) {
        this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, e.target.getAttribute('data-id'), e.target.value);
    }

    handleStatusChange(value) {
        let val = (value == true ? 1 : 0);
        this.props.popupSetPopupKey('status', val);
    }

    handleUseActivation(e) {
        this.props.popupSetPopupKey('use_active_period', !this.props.builderPopup.popup.use_active_period);
    }

    handlePopupChange(e) {
        this.props.popupSetPopupKey([e.target.getAttribute('data-id')], e.target.value);
    }

    handleScheduleChange(value, type) {
        if (!value) {
            this.props.popupSetPopupKey([type], null);
            return;
        }

        if (type == 'active_from' && this.props.builderPopup.popup.active_to != '' && this.props.builderPopup.popup.active_to) {
            if (value.isAfter(moment(this.props.builderPopup.popup.active_to))) {
                Notification.error('Invalid date range. From must be a date before To');
                return;
            }
        }

        if (type == 'active_to' && this.props.builderPopup.popup.active_from != '' && this.props.builderPopup.popup.active_from) {
            if (value.isBefore(moment(this.props.builderPopup.popup.active_from))) {
                Notification.error('Invalid date range. To must be a date after From');
                return;
            }
        }

        this.props.popupSetPopupKey([type], value.format('YYYY-MM-DD'));

    }

    handleClickUpload() {
        this.refs.dropzone.open();
    }

    handleImageUpload(files) {
        if (files.length == 0) {
            return;
        }

        this.setState({isUploading: true});

        let data = new FormData();
        data.append('file', files[0]);

        axios.post('/ajax/upload_image', data)
            .then(res => {
                this.setState({isUploading: false});
                this.props.popupSetContentData('@@' + this.props.builderPopup.component.id + '@@', res.data.url);
            }).catch(err => {
                this.setState({isUploading: false});
            });
    }

    handleAppSave(app) {
        this.props.popupSetPopupKey('app', app);
    }

    renderMail() {
        let apps = GeneralHelper.appGetType('newsletter');

        if (apps.length == 0) {
            return (
                <div>No mail provider detected</div>
            )
        }
        return <NewsletterListPicker data={this.props.builderPopup.popup.app} handleSave={this.handleAppSave} inputs={this.state.types['crall-input']} apps={apps} />
    }

    handleDisableStage() {
        this.props.popupSetSettingData('disableStage' + this.props.builderPopup.stage, !this.props.builderPopup.popup.settings['disableStage' + this.props.builderPopup.stage]);
    }

    buildSaveableObject() {
        let data = {};

        data.name = this.props.builderPopup.popup.name;
        data.custom = this.props.builderPopup.popup.custom;
        data.style = stringify(this.props.builderPopup.popup.style);
        data.app = stringify(this.props.builderPopup.popup.app);
        data.content = stringify(this.props.builderPopup.popup.content);
        data.settings = stringify(this.props.builderPopup.popup.settings);
        data.rules = this.props.builderPopup.rules;
        data.status = this.props.builderPopup.popup.status;
        data.position = this.props.builderPopup.popup.position;
        data.use_active_period = this.props.builderPopup.popup.use_active_period;
        data.active_from = this.props.builderPopup.popup.active_from;
        data.active_to = this.props.builderPopup.popup.active_to;

        return data;
    }

    overview(e) {
        e.stopPropagation();
        this.setState({showOverview: true});
    }

    save(redirect = true) {
        this.setState({showOverview: false});

        Notification.info('Saving...');

        axios.put('/popups/' + this.props.params.popup_id, this.buildSaveableObject())
            .then((response) => {
                Notification.success('Popup saved');
                if (redirect) {
                    if (this.isUsingFlows()) {
                        window.location = this.getRedirectLink();
                    } else {
                        this.props.router.push(GeneralHelper.Link('/popups'));
                    }
                }

            })
            .catch((error) => {
                Notification.error(error.message);
            });
    }


    handleCssChange(code) {
        this.setState({css: code});
    }

    saveCss() {
        this.props.popupSetPopupKey('custom', this.state.css);
        this.resetCss();
    }

    resetCss() {
        this.setState({
            css: '',
            customCssOpen: false
        });
    }

    renderCss() {
        return (
            <div className="m-t-20">
                <div className="col-sm-12">
                    <CodeMirror value={this.state.css} onChange={this.handleCssChange} options={this.codeMirrorOptions} />
                </div>
                <div className="col-sm-12 m-t-20">
                    <div className="col-sm-6 p-l-0">
                        <button type="button" className="btn btn-block btn-danger" onClick={this.resetCss} >Discard</button>
                    </div>
                    <div className="col-sm-6 p-r-0">
                        <button type="button" className="btn btn-block btn-dark" onClick={this.saveCss}>Save</button>
                    </div>
                </div>
            </div>
        )
    }

    toggleCss() {
        this.setState({
            css: this.props.builderPopup.popup.custom
        });
        this.setState({customCssOpen: true});
    }

    handleColorChange(id, value) {
        switch (id) {
            case 'container':
                this.props.popupSetStyleData('#container-stage-' + this.props.builderPopup.stage, 'background-color', value);
                break;

            default:
                this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, 'background-color', value);
                break;
        }
    }

    handleBorderChange(id, border) {
        switch (id) {
            case 'container':
                this.props.popupSetStyleData('#container-stage-' + this.props.builderPopup.stage, 'border', border);
                break;

            default:
                this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, 'border', border);
                break;
        }

    }

    clickedContentBox() {
        this.props.popupSetGlobalKey('component', false);
    }


    addStyle(id, key, value) {
        if (!this.props.builderPopup.popup.style['#' + id][key]) {
            return true;
        }

        return false;

    }

    stageTypes(types) {
        for (let i in types) {
            types[i].map(item => {
                let s = {};

                if (!this.props.builderPopup.popup.style['#' + item.id]) {
                    this.props.popupSetStyle('#' + item.id, {});
                }

                for (let style in item.styles) {
                    switch (style) {
                        case 'backgroundColor':
                            if (this.addStyle(item.id, 'background-color', item.styles[style])) {
                                this.props.popupSetStyleData('#' + item.id, 'background-color', item.styles[style]);
                            }
                            break;

                        case 'link':
                            if (this.addStyle(item.id, 'link', item.styles[style])) {
                                this.props.popupSetStyleData('#' + item.id, 'link', item.styles[style]);
                            }
                            break;

                        case 'border':
                            if (this.addStyle(item.id, 'border', item.styles[style])) {
                                this.props.popupSetStyleData('#' + item.id, 'border', `${item.styles[style].borderWidth} ${item.styles[style].borderStyle} ${item.styles[style].borderColor}`);
                            }
                            break;
                    }
                }
            });
        }
        this.setState({types: types});
    }

    get(id) {
        axios.get('/popups/' + id)
            .then((response) => {
                response.data.template.content = JSON.parse(response.data.template.content);
                try {
                    response.data.content = JSON.parse(response.data.content);
                } catch (e) {
                    response.data.content = {};
                }

                try {
                    response.data.style = JSON.parse(response.data.style);
                } catch (e) {
                    response.data.style = {};
                }

                try {
                    response.data.app = JSON.parse(response.data.app);
                } catch (e) {
                    response.data.app = {};
                }

                try {
                    response.data.settings = JSON.parse(response.data.settings);
                } catch (e) {
                    response.data.settings = {};
                }

                if (!response.data.custom) {
                    response.data.custom = '';
                }

                if (!response.data.settings) {
                    response.data.settings = {};
                }

                if (!response.data.app) {
                    response.data.app = {};
                }

                if (!response.data.style) {
                    response.data.style = {};
                }

                if (!response.data.content) {
                    response.data.content = {};
                }




                response.data.settings = new PopupSetting(response.data.settings).item;


                for (let i in response.data.template.content) {
                    if (!response.data.content[i]) {
                        response.data.content[i] = response.data.template.content[i];
                    }
                }

                if (!response.data.style) {
                    response.data.style = {};
                }


                let rules = {};


                response.data.rules.map((rule) => {
                    rules[rule.id] = rule;
                });

                this.props.popupSetGlobalKey('rules', rules);

                delete response.data.rules;
                this.props.popupSetGlobalKey('popup', response.data);

                this.setState({isLoading: false});
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    componentDidMount() {
        this.setStage(2);
        if (typeof this.props.params.popup_id !== 'undefined') {
            this.get(this.props.params.popup_id);
        } else {
            this.setState({isLoading: false});
        }
    }

    handleHtmlChange(value) {
        this.props.popupSetContentData('@@' + this.props.builderPopup.component.id + '@@', value);
    }

    handleChange(e) {
        this.props.popupSetContentData('@@' + this.props.builderPopup.component.id + '@@', e.target.value);
    }

    handleCheckboxChange(e) {
        e.stopPropagation();
        this.props.popupSetStyleData('#' + this.props.builderPopup.component.id, e.target.getAttribute('data-id'), e.target.checked);
    }

    setStage(stage) {
        this.props.popupSetGlobalKey('component', false);
        this.props.popupSetGlobalKey('stage', stage);
    }

    renderType(type, types) {
        return (
            <div className="panel-group panel-group-continuous" id={`el-setting-${type}`} aria-multiselectable="true" role="tablist">
                {types.map((el, i) => {
                    return (
                        <SidebarSettingAccordion key={i} selectedSetting={false} optionKey={`el-setting-${type}-${i}`} id={`el-setting-${type}`} title={el.title}>
                            asdfasdfasdf
						</SidebarSettingAccordion>
                    )
                })}
            </div>
        )
    }

    renderRule(rule) {
        const Comp = components['Rule' + rule.key];
        return <Comp handleRemove={this.props.popupRemoveRule} handleChange={this.props.popupSetRule} rule={rule} key={rule.id} />
    }

    handleNameChange(e) {
        this.props.popupSetPopupKey('name', e.target.value);
    }


    renderComponent() {
        let options = [];

        //managed by placeholders
        for (let i in this.props.builderPopup.component.styles) {
            switch (i) {
                case 'openNewWindow':
                    options.push(
                        <div key={`@@${this.props.builderPopup.component.id}-openNewWindow@@`} className="form-group col-sm-12">
                            <div className="checkbox-custom checkbox-primary">
                                <input key={'@@' + this.props.builderPopup.component.id + '@@'} checked={this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['openNewWindow']} data-id="openNewWindow" onChange={this.handleCheckboxChange} type="checkbox" />
                                <label>Open link in new window?</label>
                            </div>
                        </div>
                    );
                    break;
                case 'html':
                    options.push(<CKeditor key={`@@${this.props.builderPopup.component.id}-html@@`} component={'@@' + this.props.builderPopup.component.id + '@@'} change={this.handleHtmlChange} html={this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@']} />);
                    break;

                case 'text':
                    options.push(
                        <div key={`@@${this.props.builderPopup.component.id}-text@@`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Text</label>
                            <input className="form-control" key={'@@' + this.props.builderPopup.component.id + '@@'} value={this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@']} data-id="text" onChange={this.handleChange} />
                        </div>
                    );
                    break;

                case 'link':
                    options.push(
                        <div key={`@@${this.props.builderPopup.component.id}-link@@`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Link to page</label>
                            <input className="form-control" placeholder="http://www.website.com" key={'@@' + this.props.builderPopup.component.id + '@@'} value={this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['link']} data-id="link" onChange={this.handleDataChange} />
                        </div>
                    );
                    break;

                case 'video':
                    options.push(
                        <div key={`@@${this.props.builderPopup.component.id}-video@@`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Youtube video ID</label>
                            <input className="form-control" key={'@@' + this.props.builderPopup.component.id + '@@'} value={this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@']} data-id="text" onChange={this.handleChange} />
                        </div>
                    );
                    break;

                case 'image':
                    options.push(
                        <div key={`@@${this.props.builderPopup.component.id}-image@@`} className="form-group col-sm-12">
                            {
                                this.state.isUploading ?
                                    <div className="locked-overlay"><LoadingSmall /></div>
                                    : null
                            }
                            <Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.handleImageUpload}>
                                <button type="button" onClick={this.handleClickUpload} className="btn btn-dark btn-block btn-sm"><i className="icon wb-search" aria-hidden="true"></i> Upload image</button>
                            </Dropzone>
                        </div>
                    );
                    break;

                case 'placeholder':
                    options.push(
                        <div key={`@@${this.props.builderPopup.component.id}-placeholder@@`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Text</label>
                            <input className="form-control" key={'@@' + this.props.builderPopup.component.id + '@@'} value={this.props.builderPopup.popup.content['@@' + this.props.builderPopup.component.id + '@@']} data-id="placeholder" onChange={this.handleChange} />
                        </div>
                    );
                    break;

                case 'border':
                    options.push(
                        <div key={`'@@${this.props.builderPopup.component.id}-border`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Border</label>
                            <BorderPicker id={this.props.builderPopup.component.id} handleBorderChange={this.handleBorderChange} format={true} data={this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['border']} />
                        </div>
                    )
                    break;

                case 'backgroundColor':
                    options.push(
                        <div key={`'@@${this.props.builderPopup.component.id}-background-color`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Background color</label>
                            <ColorPicker id={this.props.builderPopup.component.id} color={this.props.builderPopup.popup.style['#' + this.props.builderPopup.component.id]['background-color']} handleColorChange={this.handleColorChange} />
                        </div>
                    )
                    break;
            }
        }

        //managed by styles


        return (
            <div>
                {options}
                <div className="clearfix"></div>
            </div>
        )
    }

    renderContainer() {
        let options = [];

        for (let i in this.props.builderPopup.popup.style['#container-stage-' + this.props.builderPopup.stage]) {
            switch (i) {
                case 'border':
                    options.push(
                        <div key={`'#container-stage-${this.props.builderPopup.stage}-border`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Border</label>
                            <BorderPicker id='container' handleBorderChange={this.handleBorderChange} format={true} data={this.props.builderPopup.popup.style['#container-stage-' + this.props.builderPopup.stage]['border']} />
                        </div>
                    )
                    break;

                case 'background-color':
                    options.push(
                        <div key={`'#container-stage-${this.props.builderPopup.stage}-background-color`} className="form-group col-sm-12">
                            <label className="control-label font-size-12">Background color</label>
                            <ColorPicker id='container' color={this.props.builderPopup.popup.style['#container-stage-' + this.props.builderPopup.stage]['background-color']} handleColorChange={this.handleColorChange} />
                        </div>
                    )
                    break;
            }
        }

        return (
            <div>
                {options}
                <div className="clearfix"></div>
            </div>
        )

    }

    renderSettings() {
        return (
            <div className="sidebar text m-t-20" style={this.props.style}>
                <div className="panel-group panel-group-continuous" id="popup-settings" aria-multiselectable="true" role="tablist">


                    {
                        this.props.builderPopup.popup.template.email_collection == 1
                            ?
                            <SidebarSettingAccordion selectedSetting={false} optionKey="popup-mail" parent="popup-settings" title="Newsletter integration">
                                {this.renderMail()}
                            </SidebarSettingAccordion>
                            : null
                    }

                    <SidebarSettingAccordion selectedSetting={false} optionKey="popup-dates" parent="popup-settings" title="Scheduled activation">
                        <div className="col-sm-12">
                            <div className="checkbox-custom checkbox-primary">
                                <input type="checkbox" onChange={this.handleUseActivation} checked={this.props.builderPopup.popup.use_active_period} />
                                <label>Use scheduled activation</label>
                            </div>
                        </div>

                        {this.props.builderPopup.popup.use_active_period ?
                            <div>
                                <div className="form-group col-sm-12">
                                    <label className="control-label font-size-12">From</label>
                                    <DatePicker dateFormat="DD-MM-YYYY" placeholderText="Click to select a date" selected={this.props.builderPopup.popup.active_from == '' || !this.props.builderPopup.popup.active_from ? '' : moment(this.props.builderPopup.popup.active_from)} data-id="active_from" className="form-control" onChange={(e) => {this.handleScheduleChange(e, 'active_from')}} />
                                </div>

                                <div className="form-group col-sm-12">
                                    <label className="control-label font-size-12">To</label>
                                    <DatePicker dateFormat="DD-MM-YYYY" placeholderText="Click to select a date" selected={this.props.builderPopup.popup.active_to == '' || !this.props.builderPopup.popup.active_to ? '' : moment(this.props.builderPopup.popup.active_to)} data-id="active_to" className="form-control" onChange={(e) => {this.handleScheduleChange(e, 'active_to')}} />
                                </div>
                            </div> : null}
                    </SidebarSettingAccordion>

                    <SidebarSettingAccordion selectedSetting={false} optionKey="popup-who" parent="popup-settings" title="Who">
                        <div className="list-group bg-blue-grey-100 bg-inherit">
                            {Object.keys(this.props.builderPopup.rules).map(i => {
                                return this.props.builderPopup.rules[i].action == 'Who' ? this.renderRule(this.props.builderPopup.rules[i]) : null;
                            })}
                        </div>
                        <button type="button" onClick={(e) => {e.stopPropagation(); this.setState({isAddingRule: true});}} className="btn btn-dark btn-block">Add new rule</button>
                    </SidebarSettingAccordion>

                    <SidebarSettingAccordion selectedSetting={false} optionKey="popup-when" parent="popup-settings" title="When">
                        <div className="list-group bg-blue-grey-100 bg-inherit">
                            {Object.keys(this.props.builderPopup.rules).map(i => {
                                return this.props.builderPopup.rules[i].action == 'When' ? this.renderRule(this.props.builderPopup.rules[i]) : null;
                            })}
                        </div>
                        <button type="button" onClick={(e) => {e.stopPropagation(); this.setState({isAddingRule: true});}} className="btn btn-dark btn-block">Add new rule</button>
                    </SidebarSettingAccordion>
                </div>
            </div>
        )
    }

    copyCampaignLink = () => {
        Notification.success('The link is added to your clipboard');
    }

    getCampaignLink = () => {
        let url = this.props.general.settings.SHOP_URL;

        if (!url.endsWith('/')) {
            url += '/';
        }

        url += '?cCampaign=' + this.props.builderPopup.popup.uid;

        return url;
    }

    renderSidebarContent(stage) {
        if (this.state.customCssOpen) {
            return this.renderCss();
        }

        if (this.props.builderPopup.stage == 4) {
            return this.renderSettings();
        }

        return <div className="sidebar text m-t-20" style={this.props.style}>

            {
                this.props.builderPopup.stage == 1 || this.props.builderPopup.stage == 3
                    ?
                    <div className="component m-b-20">
                        <div className="checkbox-custom checkbox-primary">
                            <input type="checkbox" onChange={this.handleDisableStage} checked={this.props.builderPopup.popup.settings['disableStage' + this.props.builderPopup.stage]} />
                            <label>Don't show <strong>{this.props.builderPopup.stage == 1 ? 'Minimized' : 'Success'}</strong> window to visitor.</label>
                        </div>
                    </div>
                    : null
            }

            {this.props.builderPopup.popup.settings['disableStage' + this.props.builderPopup.stage] == false || this.props.builderPopup.stage == 2 ?
                <div>
                    <div className="panel-group panel-group-continuous" id="box-settings" aria-multiselectable="true" role="tablist">

                        <SidebarSettingAccordion selectedSetting={false} optionKey="content-box" parent="box-settings" title="Container">
                            {this.renderContainer()}
                        </SidebarSettingAccordion>
                    </div>




                    <div className="component">
                        {
                            this.props.builderPopup.component == false ?
                                <div className="text-center">
                                    <img style={{width: '40px'}} src="/images/svg/click.svg" />
                                    <p>
                                        Click on the element you wan't to edit.
						</p>
                                </div> : this.renderComponent()
                        }
                    </div>
                </div>
                : null}
        </div>
    }

    renderPreview() {
        return (
            <PopupPreview ref={(iframe) => {this.iframe = iframe;}} stageTypes={this.stageTypes} />
        )
    }

    getRedirectLink = () => {
        if (!this.isUsingFlows()) {
            return General.Link('/popups');
        }

        return General.Link2("/popups");
    }

    isUsingFlows() {
        return this.props.general.settings.FLOW == '1' ? true : false;
    }



    render() {
        if (this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }
        return (

            <div className="height-100">
                <Nav backLink={this.getRedirectLink()} backText="Back to popups">
                    <li className="nav-item hidden-float">
                        <a className="nav-link" href="javascript:void(0)" onClick={(e) => this.setState({isAddingDiscount: true})}>Add discount <i className="icon fa-tag" style={{fontSize: '12px'}} aria-hidden="true"></i></a>
                    </li>
                    <li className="nav-item hidden-float">
                        <CopyToClipboard
                            onCopy={this.copyCampaignLink}
                            options={{message: 'Whoa!'}}
                            text={this.getCampaignLink()}>
                            <a className="nav-link" href="javascript:void(0)" onClick={this.copyCampaignLink}>Copy campaign link <i className="icon fa-copy" style={{fontSize: '12px'}} aria-hidden="true"></i></a>
                        </CopyToClipboard>
                    </li>
                    <li className="nav-item hidden-float">
                        <a className="nav-link" href="javascript:void(0)" onClick={(e) => this.toggleCss()}>Custom CSS <i className="icon wb-code-unfold" style={{fontSize: '12px'}} aria-hidden="true"></i></a>
                    </li>
                    <li className="nav-item hidden-float">
                        <a className="nav-link" href="javascript:void(0)" onClick={(e) => this.save(false)}>Quick save</a>
                    </li>
                    <li className="nav-item save-and-continue hidden-float">
                        <a className="nav-link" href="javascript:void(0)" onClick={(e) => this.overview(e)}>Save and continue <i className="fa fa-chevron-right" style={{fontSize: '12px'}} aria-hidden="true"></i></a>
                    </li>
                </Nav>

                <div className="height-100">
                    <div className="sidebar height-100 col-sm-4 p-0">
                        <div className="slide-in">
                            <div className="btn-group col-sm-12  m-t-20" aria-label="Default button group" role="group">
                                <SidebarTabButton setSelectedTab={this.setStage} colSize="col-sm-3" selectedTab={this.props.builderPopup.stage} tab="1" text="Minimized" />
                                <SidebarTabButton setSelectedTab={this.setStage} colSize="col-sm-3" selectedTab={this.props.builderPopup.stage} tab="2" text="Maximized" />
                                {this.sidebarSuccess()}
                                <SidebarTabButton setSelectedTab={this.setStage} colSize="col-sm-3" selectedTab={this.props.builderPopup.stage} tab="4" text="Settings" />
                            </div>

                            <div className="clearfix"></div>
                            {this.renderSidebarContent(this.props.builderPopup.stage)}
                            <div className="clearfix"></div>
                        </div>
                    </div>

                    <div className="main-content col-sm-8 p-0 height-100">

                        {this.renderPreview()}
                    </div>
                </div>

                <Portal closeOnEsc onClose={e => {this.setState({showOverview: false})}} isOpened={this.state.showOverview}>

                    <FullScreenOverlay>
                        <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                            <h1>Almost done!</h1>
                            <h2>Please take your time and look over the settings for this popup.</h2>

                            <div className="m-t-40 col-sm-12">
                                <div className="m-b-20 strike">
                                    <span>Name</span>
                                </div>
                                <div className="col-sm-10 offset-sm-1">
                                    <input type="text" onChange={this.handleNameChange} className="form-control form-control-lg" value={this.props.builderPopup.popup.name} placeholder="My awesome popup" />
                                </div>
                            </div>


                            <div className="m-t-40 col-sm-12">
                                <div className="m-b-20 strike">
                                    <span>Position</span>
                                </div>
                                <div className="col-sm-10 offset-sm-1">
                                    <select className="form-control" value={this.props.builderPopup.popup.position} data-id="position" onChange={this.handlePopupChange}>
                                        <option value="center">Center</option>
                                        <option value="bottom-left">Bottom-left</option>
                                        <option value="bottom-right">Bottom-right</option>
                                    </select>
                                </div>
                            </div>


                            <div className="rules m-t-40 col-sm-12">
                                <div className="m-b-20 strike">
                                    <span>Who</span>
                                </div>
                                <div className="col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit">
                                    {Object.keys(this.props.builderPopup.rules).map(i => {
                                        return this.props.builderPopup.rules[i].action == 'Who' ? this.renderRule(this.props.builderPopup.rules[i]) : null;
                                    })}
                                </div>
                            </div>

                            <div className="rules m-t-40 col-sm-12">
                                <div className="m-b-20 strike">
                                    <span>When</span>
                                </div>
                                <div className="col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit">
                                    {Object.keys(this.props.builderPopup.rules).map(i => {
                                        return this.props.builderPopup.rules[i].action == 'When' ? this.renderRule(this.props.builderPopup.rules[i]) : null;
                                    })}
                                </div>
                            </div>


                            {
                                this.props.builderPopup.popup.template.email_collection == 1
                                    ?
                                    <div className="m-t-40 col-sm-12">
                                        <div className="m-b-20 strike">
                                            <span>Newsletter integration</span>
                                        </div>
                                        <div className="col-sm-8 offset-sm-2">
                                            {this.renderMail()}
                                        </div>
                                    </div>
                                    : null
                            }

                            <div className="m-t-40 col-sm-12">
                                <div className="m-b-20 strike">
                                    <span>Popup status</span>
                                </div>
                                {
                                    this.props.general.settings.PACKAGE_POPUP == '1' ?
                                        <div className="col-sm-10 offset-sm-1">

                                            <div className="col-sm-4 text-right">
                                                Activate popup
									</div>

                                            <div className="col-sm-6 text-right">
                                                <Switch onChange={this.handleStatusChange}
                                                    checked={(this.props.builderPopup.popup.status == 1 ? true : false)}
                                                    checkedChildren={<i className="icon fa-check"></i>}
                                                    unCheckedChildren={<i className="icon fa-close"></i>}
                                                />
                                            </div>
                                        </div> :
                                        <div className="col-sm-10 offset-sm-1">
                                            <div className="col-sm-10 offset-sm-1">
                                                <UpgradeRequired message="If you want to enable popups, you need to upgrade your account to a larger package" />
                                            </div>
                                        </div>
                                }



                            </div>

                            <div className="col-sm-10 offset-sm-1">
                                <button type="button" onClick={this.save} className="btn p-l-40 p-r-40 btn-dark btn-lg m-t-50 m-b-50">Save</button>
                            </div>



                        </div>
                    </FullScreenOverlay>
                </Portal>

                <DiscountPicker onClose={() => {this.setState({isAddingDiscount: false})}} param={this.state.isAddingDiscount} />
                <RulePicker rules={this.props.builderPopup.rules} addRule={this.addRule} renderRule={this.renderRule} available={components} onClose={() => {this.setState({isAddingRule: false})}} param={this.state.isAddingRule} />

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        builderPopup: state.builderPopup,
        general: state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({popupRemoveRule, popupSetSettingData, popupSetRule, popupSetStyleData, popupSetPopupKey, popupSetGlobalKey, popupSetContentData, popupSetStyle}, dispatch)
}


Popup = connect(mapStateToProps, mapDispatchToProps)(Popup);
export default Popup;



// WEBPACK FOOTER //
// ./containers/builder/Popup.js